"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scheduleCancelVisitPayloadToFormDataHandler = scheduleCancelVisitPayloadToFormDataHandler;
function scheduleCancelVisitPayloadToFormDataHandler(data) {
    if (data.form.action === "SCHEDULE_VISIT") {
        return {
            action: data.form.action,
            futureAppointment: {
                visitDate: data.form.visitDate,
                visitStartTime: data.form.visitStartTime,
                visitEndTime: data.form.visitEndTime,
            },
            notes: data.form.notes || "",
        };
    }
    return {
        action: data.form.action,
        visitDate: data.form.visitDate,
        visitToCancel: {
            id: data.form.visitToCancel,
            visitStartTime: data.form.visitStartTime,
            visitEndTime: data.form.visitEndTime,
        },
        notes: data.form.notes || "",
    };
}
